export const JUST_SAVED_NAMED_REPORT = "saved-named-report";
